import { render } from "./SelectDachziegel.vue?vue&type=template&id=3548e7da"
import script from "./SelectDachziegel.vue?vue&type=script&lang=js"
export * from "./SelectDachziegel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Contex\\Projekte\\dev\\web\\Jacobi Walter\\Schneelastrechner\\02_web\\jacobiwalther_schneelastre_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__